<template>    
  <div class="krs019">
    <ul>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.CwpoManage.001","정보차단벽 정책명")}}</dt>
          <dd>
            <div class="txt">
              <input type="text" v-model="cwpoName" 
                    @input="displayBytes(cwpoName, $event)" 
                    :placeholder="$i18nUtil.trans('message.CwpoRegist.001','정보차단벽 정책명을 입력해 주세요.')"/>
              <div class="error" v-if="cwpoNameError">{{ $i18nUtil.trans("message.CwpoRegist.001","정보차단벽 정책명을 입력해 주세요.") }}</div>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("entity.user.deptName.002","부서명")}}</dt>
          <dd>
            <div class="txt">
              <input 
                    type="text" 
                    v-model="objectName" :placeholder="$i18nUtil.trans('message.CwpoRegist.002','부서를 선택해 주세요.')"
                    style="background-color: white; color: black;"
                    disabled
              />              
            </div>
            <button
                  type="button"
                  class="btn-primary-small"
                  @click="addDept('dept')"
                  style="right: -110px; width: 111px;"
            >{{$i18nUtil.trans("message.CwpoRegist.003","부서 추가")}}
            </button>            
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.CwpoManage.004","대상부서명")}}</dt>
          <dd>
            <div class="txt">
              <input
                    type="text"
                    v-model="blockObjectName" :placeholder="$i18nUtil.trans('message.CwpoRegist.004','대상부서를 선택해 주세요.')"
                    style="background-color: white; color: black;"
                    disabled
              />
            </div>
            <button
                  type="button"
                  class="btn-primary-small"
                  @click="shareTeam"
                  style="right: 18px"
            >{{$i18nUtil.trans("message.CwpoManage.005","팀내만 공유")}}
            </button>
            <button
                  type="button"
                  class="btn-primary-small"
                  @click="addDept('blockDept')"
                  style="right: -110px"
            >{{$i18nUtil.trans("message.CwpoManage.006","대상부서 수정")}}
            </button>
          </dd>
        </dl>
      </li>
        <button
                type="button"
                class="btn-primary-small black"
                @click="checkRegistData"
                style="float: right; margin-top: 10px;"
        >{{$i18nUtil.trans("button.save","저장")}}
        </button>
    </ul>
  </div>

</template>
<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import CoSysOrg from "@/components/cowork/common/organization/org/CoSysOrg";
export default {
  components: {
    Dialog,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      checkError: 0,
      cwpoNameError: false,      
      cwpoName: null,
      objectId: null,     
      objectName: null,
      blockObjectId: null,      
      blockObjectName: null,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3500,
        },
      },
    };
  },  
  created() {
    EventBus.$off("returnDept");
    EventBus.$on("returnDept", param => {
      let obj = this;
      if (param.deptType == "dept") {
        obj.objectName = param.deptName;
        obj.objectId = param.deptId;        
      }else{
        obj.blockObjectName = param.deptName;
        obj.blockObjectId = param.deptId;
      }
    });
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
    displayBytes(text, _event) {
            if(this.checkError == 1){
              let obj = this;
              text = _event.target.value;
              let checkBytes = obj.getByteLength(text);
              if(checkBytes > 0) {
                obj.cwpoNameError = false;
              }else{
                obj.cwpoNameError = true;
              }
            }
    },
    getByteLength(str) {
            if (str == null || str.length == 0) {
                return 0;
            }
            var size = 0;
            for ( var i = 0; i < str.length; i++) {
                size += this.charByteSize(str.charAt(i));
            }
            return size;
    },
    charByteSize(ch) {
            if (ch == null || ch.length == 0) {
                return 0;
            }
            var charCode = ch.charCodeAt(0);

            if (charCode <= 0x00007F) {
                return 1;
            } else if (charCode <= 0x0007FF) {
                return 2;
            } else if (charCode <= 0x00FFFF) {
                return 2;
            } else {
                return 2;
            }
    },
    checkRegistData(){      
      this.checkError = 1;
      if(this.cwpoName == null || this.cwpoName == undefined || this.cwpoName.length == 0){
        this.cwpoNameError = true;
        return;
      }else{
        this.cwpoNameError = false;
      }
      if(this.objectId == null && this.blockObjectId == null){
        this.toastInfo.message = this.$i18nUtil.trans("message.CwpoRegist.005","부서와 대상부서를 선택해 주세요.");
        this.showToast(this.toastInfo);
      }else if(this.objectId == null){
        this.toastInfo.message = this.$i18nUtil.trans("message.CwpoRegist.002","부서를 선택해 주세요.");
        this.showToast(this.toastInfo);
      }else if(this.blockObjectId == null){
        this.toastInfo.message = this.$i18nUtil.trans("message.CwpoRegist.004","대상부서를 선택해 주세요.");
        this.showToast(this.toastInfo);
      }else if(this.objectId == this.blockObjectId){
        this.toastInfo.message = this.$i18nUtil.trans("message.CwpoManage.007","부서와 대상부서는 동일한 부서로 선택할 수 없습니다.");
        this.showToast(this.toastInfo);
      }else {
        this.registCwpo();
        this.checkError = 0;
      }            
    },
    registCwpo() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        cwpoName: obj.cwpoName,
        objectId: obj.objectId,     
        blockObjectId: obj.blockObjectId,
      };
      reqData.url = "/api/org/cwpo/registCwpo";
      reqData.method = "post";

      //프로그레스바 시작
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          obj.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          }else{
            if(res.result != null){
              if(res.result == "objDupl"){
                obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoRegist.006","기존의 정책과 중복 되는 정책이므로 등록할 수 없습니다. 부서명과 대상부서명을 다시 선택해 주세요.");
                obj.showToast(obj.toastInfo);
              }else if(res.result == "blockObjDupl"){
                obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoRegist.006","기존의 정책과 중복 되는 정책이므로 등록할 수 없습니다. 부서명과 대상부서명을 다시 선택해 주세요.");
                obj.showToast(obj.toastInfo);
              }else if(res.result.resultMessage == "EXIST_POLICY"){
                // obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoManage.008","기존의 정책과 중복 되는 정책이므로 수정할 수 없습니다. 부서명과 대상부서명을 다시 수정해 주세요.");
                let policyName = "";
                res.result.policyNameList.forEach(element => {
                  policyName += "["+element+"]";
                });
                obj.toastInfo.message = "부서 정책이 존재합니다. 해당 정책 삭제 후 추가 시도 부탁 드립니다.<br>"+policyName;

                obj.showToast(obj.toastInfo);
              }
            }else{                
              obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoRegist.007","정보차단벽 정책이 등록되었습니다.");
              obj.showToast(obj.toastInfo);
              obj.$emit("registCwpo");
              obj.cwpoName = null;
              obj.objectName = null;
              obj.objectId = null;
              obj.blockObjectName = null;            
              obj.blockObjectId = null;
            }
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    addDept(deptType){
      let modalInfo = {};      
        modalInfo = {
          obj: this.$modal,
          component: CoSysOrg,
          deptType: deptType,
          width: "600px",
          height: "450px",          
        };
      this.showModal(modalInfo);
    },
    shareTeam(){
      this.blockObjectId = 'ALL';
      this.blockObjectName = 'ALL';
    },
  },
};
</script>

<style scoped>
.krs019 > ul > li > dl > dt {
  width: 150px;
  padding-top: 5px;
}
.krs019 > ul > li > dl > dd {
  width: 900px;
}
.krs019 > ul > li > dl > dd > div > input {
  width: 85%;
  border: 1px solid #E6E6E8;
}
.krs019 > ul > li > dl > dd > div > div {
  width: 15%;
  float: right;  
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/CwpoRegist.vue